var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrabHandleDots(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 8.208,
    height: 15.532,
    viewBox: "0 0 8.208 15.532",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "grab_handle-dots_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.208,
    height: 15.532,
    fill: "#979797"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#grab_handle-dots_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.035,244.07A1.035,1.035,0,1,0,0,243.035a1.036,1.036,0,0,0,1.035,1.035",
    transform: "translate(0 -228.537)",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.035,123.469A1.035,1.035,0,1,0,0,122.435a1.036,1.036,0,0,0,1.035,1.035",
    transform: "translate(0 -114.646)",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.035,2.87A1.035,1.035,0,1,0,0,1.835,1.036,1.036,0,0,0,1.035,2.87",
    transform: "translate(0 -0.755)",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.367,243.27a1.035,1.035,0,1,0-1.035-1.035,1.036,1.036,0,0,0,1.035,1.035",
    transform: "translate(-104.194 -227.782)",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.367,122.67a1.035,1.035,0,1,0-1.035-1.035,1.036,1.036,0,0,0,1.035,1.035",
    transform: "translate(-104.194 -113.892)",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.367,2.07a1.035,1.035,0,1,0-1.035-1.035,1.036,1.036,0,0,0,1.035,1.035",
    transform: "translate(-104.194)",
    fill: "#979797"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrabHandleDots);
export default __webpack_public_path__ + "static/media/grab_handle-dots.2fb5c9ea42b7ccc56b891562f43a284b.svg";
export { ForwardRef as ReactComponent };